
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1ifko_e6mfe_141",
  "disable-paddings": "awsui_disable-paddings_1ifko_e6mfe_180",
  "main": "awsui_main_1ifko_e6mfe_184",
  "actions": "awsui_actions_1ifko_e6mfe_191",
  "content-wrap": "awsui_content-wrap_1ifko_e6mfe_195",
  "wrap-actions": "awsui_wrap-actions_1ifko_e6mfe_205",
  "content": "awsui_content_1ifko_e6mfe_195"
};
  